import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { registry as getMicrofrontendsRegistry } from '@cian/mf-registry/browser';

import { IApplicationContext, IApplicationContextCustom } from '../../../shared/types/app';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    config,
    logger: getLogger(),
    httpApi: getHttpApi(),
    custom: config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
    microfrontendsRegistry: getMicrofrontendsRegistry(),
  };
};
